/* React */
import React, { useEffect, useState } from "react";

/* Ionic */
import { IonBackdrop } from "@ionic/react";
import { close, filter } from "ionicons/icons";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";
import FilterContainer from "src/components/chart-wrapper/toolbar/options/horizontal-boxplot-options/treatment-line-filter/filter-container/FilterContainer";

/* Stylesheet */
import styles from "./TreatmentLineFilter.module.scss";

/* Interfaces */
import { BoxplotProps } from "src/shared/interfaces/Boxplot";

interface TreatmentFilterProps {
  data: BoxplotProps[];
  selectedTLs: string[];
  handleSelectedTLs: (treatmentLines: string[]) => void;
  activeIndex?: number;
}

const TreatmentLineFilter: React.FC<
  TreatmentFilterProps
> = ({
  data,
  selectedTLs,
  handleSelectedTLs,
  activeIndex,
}) => {
  const [showFilter, setShowFilter] =
    useState<boolean>(false);

  useEffect(() => {
    setShowFilter(false);
  }, [activeIndex]);

  return (
    <div className={styles.treatment_line_filter}>
      <PrimaryFabButton
        className={"primary small"}
        icon={showFilter ? close : filter}
        ariaLabel="Filter treatments"
        onClick={() => setShowFilter(!showFilter)}
      />
      {showFilter ? (
        <>
          <FilterContainer
            data={data}
            selectedTLs={selectedTLs}
            handleSelectedTLs={handleSelectedTLs}
          />
          <IonBackdrop
            className={styles.backdrop}
            onIonBackdropTap={() => setShowFilter(false)}
          />
        </>
      ) : undefined}
    </div>
  );
};

export default TreatmentLineFilter;
